import { modules, courses } from '../constants';

// The level-4 trainer module is course-specific: C5 uses TRAIN_THE_TRAINER,
// YOUNG_PEOPLE uses TRAINER_UPSKILL. Modules 1-3 are shared by both courses.
const moduleForCourse = (course, module) => {
  if (course === courses.C5 && module === modules.TRAINER_UPSKILL) {
    return modules.TRAIN_THE_TRAINER;
  }
  if (course === courses.YOUNG_PEOPLE && module === modules.TRAIN_THE_TRAINER) {
    return modules.TRAINER_UPSKILL;
  }
  return module;
};

export default moduleForCourse;
